export default __webpack_public_path__ + "static/media/pin.6aac214c.svg";